import { cva } from "class-variance-authority";
import { cn } from "@/lib/cn";

const statCardVariants = cva(
  "rounded-[0.8rem] border p-2.5 md:p-3.5",
  {
    variants: {
      tone: {
        default: "border-border/90 bg-panel/82",
        success: "border-green-500/35 bg-green-500/8",
        warning: "border-brand-500/45 bg-brand-500/10",
        danger: "border-red-500/45 bg-red-500/8",
      },
    },
    defaultVariants: { tone: "default" },
  },
);

interface StatCardProps {
  label: string;
  value: string;
  hint?: string;
  tone?: "default" | "success" | "warning" | "danger";
}

export function StatCard({ label, value, hint, tone = "default" }: StatCardProps) {
  return (
    <article className={cn(statCardVariants({ tone }))} data-tone={tone}>
      <div className="text-[0.65rem] md:text-[0.72rem] text-muted">{label}</div>
      <div className="mt-0.5 text-lg md:text-xl font-bold text-text">{value}</div>
      {hint ? <div className="mt-1 md:mt-1.5 text-[0.65rem] md:text-[0.72rem] text-muted">{hint}</div> : null}
    </article>
  );
}
